// Keys stay in snake_case: the rules are stored as JSON on the backend and are not camelCased on the way
export interface MinQuantityRule {
    extra_data_key: string;
    mode: 'minimum' | 'multiple';
    quantity_field: 'quantity' | 'converted_quantity';
    value_locale: 'en' | 'de';
    is_blocking: boolean;
    lookup_definition_id?: string | null;
}

export const NEW_MIN_QUANTITY_RULE: MinQuantityRule = {
    extra_data_key: '',
    mode: 'minimum',
    quantity_field: 'quantity',
    value_locale: 'en',
    is_blocking: true,
};

export const normalizeMinQuantityRules = (rules?: MinQuantityRule[] | null): MinQuantityRule[] =>
    (rules || []).map((rule) => ({
        ...NEW_MIN_QUANTITY_RULE,
        ...rule,
        extra_data_key: (rule.extra_data_key || '').trim(),
        lookup_definition_id: (rule.lookup_definition_id || '').trim() || null,
    }));

const RULE_KEYS = [
    'extra_data_key',
    'mode',
    'quantity_field',
    'value_locale',
    'is_blocking',
    'lookup_definition_id',
] as const;

// Pasted text comes from "Copy rules"; anything else must not reach the backend, which rejects unknown keys
export const parseMinQuantityRules = (text: string): MinQuantityRule[] => {
    const parsed = JSON.parse(text);
    if (!Array.isArray(parsed) || parsed.some((rule) => !rule || typeof rule !== 'object' || Array.isArray(rule))) {
        throw new Error('Expected a list of minimum quantity rules');
    }
    return parsed.map((rule) => {
        const known = Object.fromEntries(RULE_KEYS.filter((key) => key in rule).map((key) => [key, rule[key]]));
        return { ...NEW_MIN_QUANTITY_RULE, ...known };
    });
};

export const validateMinQuantityRules = (rules?: MinQuantityRule[] | null): boolean =>
    (rules || []).every((rule) => (rule.extra_data_key || '').trim() !== '');
